import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SortOptionModel, SortService } from '../../services/sort.service';
import { NgClass } from '@angular/common';
import {
	ArrowDownSvgComponent,
	SortArrowsSvgComponent,
	TickSvgComponent,
} from '@uc/shared/svg';
import { FormsModule } from '@angular/forms';
import { DropdownDirective } from '@uc/utilities';

@Component({
	selector: 'uc-sort',
	templateUrl: './sort.component.html',
	imports: [
		NgClass,
		FormsModule,
		SortArrowsSvgComponent,
		ArrowDownSvgComponent,
		TickSvgComponent,
		DropdownDirective,
	],
})
export class SortComponent implements OnInit, OnDestroy {
	@Input() sortOptions!: SortOptionModel[];
	@Input() customStyles!: string;
	@Input() buttonWidth = 'w-auto';
	@Input() showSelectOnDesktop = false;
	optionSelected!: SortOptionModel;

	private selectSubscription!: Subscription;

	constructor(private _sortSrv: SortService) {}

	ngOnInit(): void {
		this.optionSelected = this._sortSrv.defaultOption;
		this.selectSubscription = this._sortSrv.selectedOption$.subscribe((data) => {
			if (data) this.optionSelected = data;
		});
	}

	ngOnDestroy(): void {
		this.selectSubscription.unsubscribe();
	}

	onSortOption(option: SortOptionModel) {
		this.optionSelected = option;
		this._sortSrv.onSortOption(option);
	}
}
